// Fills %{name} placeholders in a translation handed to JavaScript through a
// data attribute. Same placeholder syntax as the YAML files, so a string can be
// moved between a view and a controller without rewriting it.
export function interpolate(template, values = {}) {
  if (typeof template !== "string") return "";

  return template.replace(/%\{(\w+)\}/g, (_match, name) =>
    values[name] === undefined || values[name] === null ? "" : String(values[name])
  );
}
